import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=94b897ba&scoped=true"
import script from "./AgentList.vue?vue&type=script&lang=js"
export * from "./AgentList.vue?vue&type=script&lang=js"
import style1 from "./AgentList.vue?vue&type=style&index=1&id=94b897ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b897ba",
  null
  
)

export default component.exports